import { ContextBuilder } from 'context/nutriscoreLabelContext';
import { useParams } from 'react-router-dom';

import IngredientComponent from 'components/desktop/Ingredient/IngredientComponent';
import { Optional } from 'functions/promiseExtensions';
import useCurrency from 'hooks/redux/useCurrency';
import { useReaction } from 'hooks/useReaction';
import * as Ingredient from 'types/Ingredient/Detail/Ingredient';

const IngredientDetailContainer = () => {
	const { id } = useParams();
	const currency = useCurrency();

	const [ingredient, isLoaded] = useReaction(
		Optional.None<Ingredient.Type>(),
		Ingredient.getFromApiOrCreate,
		id,
		currency,
		location.pathname.includes('/copy') ? true : false
	);

	return (
		<main className="container">
			{ingredient.hasValue() && (
				<IngredientComponent initialState={ingredient.get()} isLoading={!isLoaded} />
			)}
		</main>
	);
};

export default ContextBuilder.From(IngredientDetailContainer).wrapWithNutriscoreContext().build();
